import { z } from "zod/v4";

export const GetBillingUrlRequestBodySchema = z.object({
  subscriptionIds: z.string().array(),
  code: z.string().optional(),
});

export const GetBillingUrlResponseBodySchema = z.object({
  billingUrl: z.string().optional(),
});

export type GetBillingUrlRequestBodyType = z.infer<
  typeof GetBillingUrlRequestBodySchema
>;
export type GetBillingUrlResponseBodyType = z.infer<
  typeof GetBillingUrlResponseBodySchema
>;
